<template>
    <main id="home-wrapper">
        <div id="homepage">
            <breadcrumb
                :breadcrumb="[
                    { title: 'Community', url: app_url+'/', status: false },
                    { title: 'Event', url: app_url+'/event', status: true }
                ]"
            ></breadcrumb>

            <section id="upcoming-events" class="section withPad blackBg">
                <div class="container">
                    <div class="section_title">
                        <h3>Cari Event Berdasarkan</h3>
                    </div>
                    <div class="row_filter">
                        <div class="row-grid">
                            <!-- <div class="col-grid-40">
                                <date-picker v-model="range" is-range  :model-config="modelConfig">
                                <template v-slot="{ inputValue, inputEvents }">
                                    <div class="flex-centers">
                                    <input
                                        :value="inputValue.start"
                                        v-on="inputEvents.start"
                                        class="form-control"
                                        placeholder="Tanggal Mulai"
                                    />
                                    <svg
                                        class="arrow"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                    >
                                        <path
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-width="2"
                                        d="M14 5l7 7m0 0l-7 7m7-7H3"
                                        />
                                    </svg>
                                    <input
                                        :value="inputValue.end"
                                        v-on="inputEvents.end"
                                        class="form-control"
                                        placeholder="Tanggal Akhir"
                                    />
                                    </div>
                                </template>
                                </date-picker>
                            </div> -->

                            <div class="col-grid-20">
                                <div class="custom_vselect custom_vselect-medium">
                                    <v-select
                                        :options="months"
                                        label="name"
                                        placeholder="Pilih Bulan"
                                        @input="changeMonth($event,'month')"
                                        v-model="month"
                                    >
                                    </v-select>
                                </div>
                            </div>
                            <div class="col-grid-20">
                                <div class="custom_vselect custom_vselect-medium">
                                    <v-select
                                        :options="event_types"
                                        label="name"
                                        placeholder="Pilih Tipe Event"
                                        @input="changeType($event,'event_type')"
                                        v-model="event_type"
                                    >
                                    </v-select>
                                </div>
                            </div>

                            <div class="col-grid-20" v-if="queryString.event_type == 'event_produk'">
                                <div class="custom_vselect custom_vselect-medium">
                                    <v-select
                                        :options="products"
                                        label="name"
                                        placeholder="Produk"
                                        @input="changeProduct($event,'product')"
                                        v-model="product"
                                    >
                                    </v-select>
                                </div>
                            </div>

                            <div class="col-grid-20">
                            <div class="custom_vselect custom_vselect-large">
                                <v-select
                                    :options="provinces"
                                    label="name"
                                    :placeholder="provincePlaceholder"
                                    @input="changeProvince($event,'province')"
                                    v-model="province"
                                >
                                </v-select>
                            </div>
                            </div>

                            <div class="col-grid-10">
                                <div class="cta-product-box red_submit">
                                    <a @click="goSearch" class="tx-white goSearch"
                                        >Submit
                                        <span
                                            ><i
                                                class="ion-ios-arrow-thin-right"
                                            ></i></span
                                    ></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="inner_section">
                    <div class="container">
                        <div v-if="loader" class="loading loading-double"></div>
                        <div v-else class="list-event">
                            <EventList :eventData="eventData" @getAllData="getEvent" :selectedMonth="month" :selectedProvince="province"></EventList>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </main>
</template>

<script>
import BreadCrumb from "../../widget/BreadCrumb";
import EventList from "../event/EventList";
import { isMobile } from "mobile-device-detect";
import 'vue-select/dist/vue-select.css';
import vSelect from "vue-select";

export default {
    components: {
        breadcrumb: BreadCrumb,
        "v-select": vSelect,
        EventList
    },
    data() {
        return {
            currentUrl: '',
            base_url:'',
            app_url:'',
            api_url:'',
            mobile: false,
            eventData: null,
            loader:true,
            months:[{name :'Januari', value: '01'},{name :'Februari', value: '02'},{name :'Maret', value: '03'},{name :'April', value: '04'},{name :'Mei', value: '05'},{name :'Juni', value: '06'},{name :'Juli', value: '07'},{name :'Agustus', value: '08'},{name :'September', value: '09'},{name :'Oktober', value: '10'},{name :'November', value: '11'},{name :'Desember',  value:'12'}],
            month:'',
            event_types:[{name : 'Event Nasional', type: 'event_nasional'},{name : 'Event Produk', type: 'event_produk'},{name : 'Event Paguyuban', type: 'event_paguyuban'}],
            event_type:'',
            products:[{name : 'X ADV'},{name : 'Honda Monkey'}],
            product:'',
            provinces:[],
            province:'',
            provincePlaceholder:'Pilih Lokasi',
            range: {
                start: null,
                end:null
            },
            modelConfig: {
                type: 'string',
                mask: 'YYYY-MM-DD', // Uses 'iso' if missing
            },
            endpoint:api_url+`/event/hcid`,
            queryString:{
                start_date: null,
                end_date:null,
                month:null,
                product_id:null,
                province_id:null,
                event_type:'',
                page:1,
                limit:12,
            },
        };
    },
    created() {
        this.currentUrl = window.location.href;
        this.base_url = base_url;
        this.app_url = app_url;
        this.api_url = api_url;
        this.mobile = isMobile;
        this.getEvent();
        this.getProduct();
        this.getProvince();
    },
    methods: {
        // GTM Tracker
        gtmTrackerEvent() {
            var data = {
                'event': 'eventsSearch',
                'eventDetail.category': 'Custom Event',
                'eventDetail.action':'Events Search',
                'eventDetail.label': this.event_type?.name !== undefined ? this.event_type.name : 'All',
                'month': this.month?.name ?? 'All',
                'province': this.province?.name ?? 'All'
            }
            // console.log(data)
            dataLayer.push(data);
        },
        // End GTM Tracker
        getEvent(e) {
            this.loader = true;
            const mobileStatus = this.mobile ? 1 : 0;
            let url = this.endpoint;
            if(e) url = e;
            axios
                .get(url)
                .then(res => {
                    this.loader = false;
                    // console.log(res);
                    if (res.status == 200) {
                        if (res?.data?.status) {
                            this.eventData = res?.data?.data;
                        }
                    }
                })
                .catch(err => {
                    this.loader = false;
                    console.log(err);
                });
        },
        goSearch(){
            this.queryString.start_date =  this.range.start;
            this.queryString.end_date =  this.range.end;
            this.endpoint = api_url+this.buildQuery();
            this.gtmTrackerEvent();
            this.getEvent();
        },
        getProduct(e) {
            const mobileStatus = this.mobile ? 1 : 0;
            let url = api_url+'/static/motor';
            if(e) url = e;
            axios
                .get(url)
                .then(res => {
                    // console.log(res);
                   this.products = res.data.data.bike_type;
                })
                .catch(err => {
                    console.log(err);
                });
        },
        getProvince() {
                this.loadderforms = true;
                axios.get(api_url+'/static/province')
                    .then(response => {
                        this.provinces = response.data.data.provincy;
                        this.provinces.unshift(
                        {
                            "_id": 'nasional',
                            "name": "Nasional",
                            "slug": "nasional",
                        });
                        this.loadderforms = false;
                    }).catch(error => {
                        console.log(error);
                    });
        },
        changeProvince(event,label){
            if(event){
              this.province = event;
              this.queryString.province_id = event._id;
            }else{
              this.queryString.province_id = null;
            }
        },
        changeType(event,label){
            if(event){
            this.queryString.event_type =event.type;
            }else{
              this.queryString.event_type = null;
            }
        },
        changeMonth(event,label){
            if(event){
            this.queryString.month =event.value;
            }else{
              this.queryString.month = null;
            }
        },
        changeProduct(event,label){
            if(event){
            this.queryString.product_id =event._id;
            }else{
              this.queryString.product_id = null;
            }
        },
        buildQuery() {
            return this.buildUrl('/event/hcid',this.queryString);
        },
        buildUrl(url, parameters){
            var qs = "";
            for(var key in parameters) {
            var value = parameters[key];
            if (value) {
                qs += encodeURIComponent(key) + "=" + value + "&";
            }
            }
            if (qs.length > 0){
            qs = qs.substring(0, qs.length-1);
            url = url + "?" + qs;
            }
            return url;
        },
    }
};
</script>

<style scoped lang="scss">
.img-promo-section {
    border-radius: 0px;
    overflow: hidden;
    img {
        width: 100%;
    }
}
.goSearch{
    cursor: pointer;
}
.goSearch:hover{
    color:#fff;
    background-color: #333;
}
.content-promo-section {
    padding-right: 120px;
    padding-left: 40px;
}
.wrap-label {
    justify-content: start;
}
.wrap-label span {
    font-size: 12px;
    font-weight: 500;
    display: inline-block;
    margin-right: 10px;
}
.date-news span,
.date-news p {
    display: inline-block;
}
.date-news span {
    font-size: 15px;
    margin-right: 5px;
}
.title-promo {
    margin-bottom: 20px;
    h2 {
        margin-top: 0;
        color: #fff;
        margin-bottom: 20px;
    }
    p {
        margin: 0;
        line-height: 24px;
        color: #8e8e8e;
    }
}
.btn-share {
    position: relative;
}
.btn-share {
    margin-left: auto;
}
.btn-share a {
    margin-top: 15px;
    border-radius: 100px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    width: 35px;
    height: 35px;
    line-height: 35px;
    text-align: center;
    display: inline-block;
    cursor: pointer;
    color: #fff;
    background-color: transparent;
}
.btn-share a:hover {
    background-color: #e61b33;
    color: #fff;
}
.active .shares {
    width: 150px;
    left: 42px;
}
.active .shares {
    width: 150px;
}
.active .sharebtn {
    color: #999;
    background-color: #f2f2f2;
}
.shares {
    position: absolute;
    bottom: 0;
    left: 35px;
    height: 35px;
    width: 0;
    overflow: hidden;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;
    a {
        margin: 0 4px;
    }
}
.offset-section {
    padding-left: 7em;
}
.list-logo .row-grid {
    -webkit-flex-wrap: wrap;
    flex-wrap: wrap;
}
.form-control{
    padding: 12px 15px;
    border-radius: 8px;
    height: 43px;
    line-height: 43px;
    font-size: 14px;
    width: 100%;
}
.flex-centers{
    display: flex;
    justify-content: center;
    align-items: center;
}
.arrow{
    color:#fff;
    margin:0 10px;
    min-width: 15px;
    max-width: 15px;
}
</style>
